import { ScoreName } from '../../jscaip/ScoreName';
export class GoPhase {
    static PLAYING = new GoPhase();
    static PASSED = new GoPhase();
    static COUNTING = new GoPhase();
    static ACCEPT = new GoPhase();
    static FINISHED = new GoPhase();
    constructor() {
    }
    toString() {
        switch (this) {
            case GoPhase.PLAYING: return 'PLAYING';
            case GoPhase.PASSED: return 'PASSED';
            case GoPhase.COUNTING: return 'COUNTING';
            case GoPhase.ACCEPT: return 'ACCEPT';
            case GoPhase.FINISHED: return 'FINISHED';
        }
        return '';
    }
    isPlaying() {
        return this === GoPhase.PLAYING;
    }
    isPassed() {
        return this === GoPhase.PASSED;
    }
    isCounting() {
        return this === GoPhase.COUNTING;
    }
    isAccept() {
        return this === GoPhase.ACCEPT;
    }
    isFinished() {
        return this === GoPhase.FINISHED;
    }
    allowsPass() {
        return this.isFinished() === false;
    }
    getScoreName() {
        if (this.isPlaying() || this.isPassed()) {
            return ScoreName.CAPTURES;
        }
        else {
            return ScoreName.POINTS;
        }
    }
}
